import { requireStates, ConnectComponent2 } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";
import View from "./view";
import Presenter from "./presenter";

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);

const initialStates = [
  {
    name: "app.accountant",
    url: "/area-do-contador",
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar,
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 600,
        state: "app.accountant",
        name: "Área do Contador",
        hasDivider: true
      },
      authorization: () => true
    }
  }
];

const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/index.js